import { InvoiceTaskDocument } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1910. 請求タスクファイル登録
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:invoice_task_id/invoice_task_documents
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  name: string;
  file?: string;
  url?: string;
};

const createInvoiceTaskDocument = (props: Props): Promise<InvoiceTaskDocument> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks/${props.task_id}/invoice_task_documents`,
    props
  );
};

export const useCreateInvoiceTaskDocument = () => {
  return useMutation({
    mutationFn: createInvoiceTaskDocument
  });
};
